import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberSuffix'
})
export class NumberSuffixPipe implements PipeTransform {
  transform(input: any, args?: any): any {
    let exp;
    const suffixes = ['K', 'M', 'B', 'T', 'P', 'E'];
    const isNagtiveValues = input < 0;
    if (Number.isNaN(input) || (input < 1000 && input >= 0) || !this.isNumeric(input) || (input < 0 && input > -1000)) {
      if (!!args && this.isNumeric(input) && !(input < 0) && input != 0) {
        return '₹' + input;
      } else {
        return input;
      }
    }

    if (!isNagtiveValues) {
      if(input.toString().length > 7) {
        if(input.toString().length > 8) { 
          const sliceStr = input.toString().slice(0,4);
          return '₹' + sliceStr.slice(0,2) + '.' + sliceStr.slice(2,4) + "Cr";
        } 
        const sliceStr = input.toString().slice(0,4);
        return '₹' + sliceStr.slice(0,1) + '.' + sliceStr.slice(1,3) + "Cr";
      } else if(input.toString().length > 5) {
        if(input.toString().length > 6) { 
          const sliceStr = input.toString().slice(0,4);
          return '₹' + sliceStr.slice(0,2) + '.' + sliceStr.slice(2,4) + "L";
        }
        const sliceStr = input.toString().slice(0,4);
        return '₹' + sliceStr.slice(0,1) + '.' + sliceStr.slice(1,3) + "L";
      } else if (input.toString().length > 4) {
        const sliceStr = input.toString().slice(0,4);
        return '₹' + sliceStr.slice(0,2) + '.' + sliceStr.slice(2,4) + "K";
      } else {
        return '₹' + input;
      }
    } else {
      input = input * -1;

      exp = Math.floor(Math.log(input) / Math.log(1000));

      return (input * -1 / Math.pow(1000, exp)).toFixed(args) + suffixes[exp - 1];
    }
    
  }
  isNumeric(value: number): boolean {
    if (value < 0) value = value * -1;
    if (/^-{0,1}\d+$/.test(value.toString())) {
      return true;
    } else if (/^\d+\.\d+$/.test(value.toString())) {
      return true;
    } else {
      return false;
    }
  }
}